import { GridLocaleText } from '@mui/x-data-grid';
import { SxProps, Theme } from '@mui/material/styles';

/**
 * Configuração de locale padrão para todos os DataGrids do sistema
 */
export const getDataGridLocaleText = (
    totalRecords: number,
    pageSize: number
): Partial<GridLocaleText> => ({
    noRowsLabel: "Não foi encontrado resultados",
    MuiTablePagination: {
        labelDisplayedRows: ({ count, page }) => {
            const totalPages = Math.max(1, Math.ceil(count / pageSize));
            const currentPage = page + 1; // Converte página 0-based para 1-based para exibição
            return `Página ${currentPage} de ${totalPages} | Total de Registros: ${totalRecords}`;
        },
    }
});

/**
 * Estilos sx padrão para todos os DataGrids do sistema
 */
export const dataGridDefaultSx: SxProps<Theme> = {
    '& .MuiDataGrid-row': {
        cursor: 'pointer',
    },
    '.MuiDataGrid-virtualScroller': {
        overflowY: 'auto !important',
        maxHeight: '50vh !important',
    },
};

/**
 * Props padrão comuns para todos os DataGrids
 */
export const dataGridDefaultProps = {
    pagination: true as const,
    hideFooterSelectedRowCount: true,
    disableRowSelectionOnClick: true,
    pageSizeOptions: [] as number[],
    paginationMode: 'server' as const,
};
